// Module
var code = "<div class=\"col-xs-4\"> <label class=\"control-label\">User</label> <div class=\"form-control-static\"> {{::ctrl.item.objectDetail.DisplayName || (ctrl.item.objectDetail.FirstName + ' ' + ctrl.item.objectDetail.LastName) }} </div> </div> ";
// Exports
export default code;